import find from 'lodash/find';

const getIsVideoHomeEditor = ({ organizationPermissions, orgId }) => {
  const currentOrganizationId = Number(orgId);

  const foundOrg = find(
    organizationPermissions.data.organization_video_permissions,
    (item) => item.organization_id === currentOrganizationId,
  );
  return Boolean(foundOrg && foundOrg.allow_admin_view && foundOrg.video_home_editor);
};

const getIsLiveVideoCreator = ({ organizationPermissions, orgId }) => {
  const currentOrganizationId = Number(orgId);

  const foundOrg = find(
    organizationPermissions.data.organization_video_permissions,
    (item) => item.organization_id === currentOrganizationId,
  );
  return Boolean(foundOrg && foundOrg.allow_admin_view && foundOrg.live_video_creator);
};

const getCanReorderWithinTopic = ({ item }) => item.has_editor_permission;

const getHasAccessToAncestor = ({ ancestorId, flattenedVideosAdminTree }) => {
  const flattenedTree = flattenedVideosAdminTree.data;
  const foundAncestor = find(flattenedTree, (topic) => topic.id === ancestorId);

  return foundAncestor?.has_editor_permission;
};

const getCanCreateWithinContent = ({ id, flattenedVideosAdminTree }) => {
  const topicId = id;
  const flattenedTree = flattenedVideosAdminTree.data;
  const foundTopic = find(flattenedTree, (topic) => topic.id === Number(topicId));

  return foundTopic?.has_editor_permission;
};

export const hasPermission = ({
  authority,
  organizationPermissions,
  permission,
  item = {},
  ancestorId = null,
  flattenedVideosAdminTree = [],
  params,
}) => {
  if (authority === 'superadmin') return true;

  const { id, orgId } = params;

  switch (permission) {
    case 'isVideoHomeEditor': {
      return getIsVideoHomeEditor({ organizationPermissions, orgId });
    }
    case 'hasAccessToAncestor': {
      return getHasAccessToAncestor({ ancestorId, flattenedVideosAdminTree });
    }
    case 'isLiveVideoCreator': {
      return getIsLiveVideoCreator({ organizationPermissions, orgId });
    }
    case 'hasAccessToReorderWithinContent': {
      return getCanReorderWithinTopic({ item });
    }
    case 'hasAccessToCreateWithinContent': {
      return getCanCreateWithinContent({ id, flattenedVideosAdminTree });
    }
    default: {
      return false;
    }
  }
};

export default hasPermission;
